import { FormGroup } from '@angular/forms';
import { GoogleTagManagerService } from 'angular-google-tag-manager';
import { FormName } from 'src/app/core/interfaces/form-name.interface';
import { ListaGarantiasInterface } from 'src/app/core/interfaces/presupuesto-guardar.interface';
import { Numbers } from 'src/app/utils/constants';

export default class LegalStepThreeComponentUtils {
  /**
   * datalayer
   * @param id id
   * @param price price
   * @param formData formData
   * @param gtmService gtmService
   */
  datalayer(id: any, price: any, formData: FormGroup, gtmService: GoogleTagManagerService): void {
    const formName: FormName = this.getFormData(formData);
    const formNameS = 'seguro de asistencia ' + formName.layerName;
    const productLayer: any = {
      name: formNameS,
      id: id.toString(),
      price: (price.toFixed(Numbers.number2)).toString(),
      brand: formName.layerName,
      category: 'jurídico',
      variant: '-',
      quantity: 1,
      list: 'contrata_online'
    };
    const datalayerD: {
      event: string;
      ecommerce: {
        currencyCode: string;
        add: {
          products: any[];
        };
      };
    } = {
      event: 'ev_addToCart',
      ecommerce: {
        currencyCode: 'EUR',
        add: {
          products: [productLayer]
        }
      }
    };
    const actionField: {
      id: any;
      affiliation: string;
      revenue: any;
      tax: string;
    } = {
      id: id.toString(),
      affiliation: 'Banco',
      revenue: (price.toFixed(Numbers.number2)).toString(),
      tax: '-'
    };
    localStorage.removeItem('layer1');
    localStorage.setItem('layer1', JSON.stringify(actionField));
    localStorage.removeItem('layer2');
    localStorage.setItem('layer2', JSON.stringify(productLayer));
    gtmService.pushTag(datalayerD);
  }

  /**
   * datalayer2
   * @param formData formData
   * @param gtmService gtmService
   */
  datalayer2(formData: FormGroup, gtmService: GoogleTagManagerService): void {
    const formName: any = this.getFormData(formData);
    const datalayerD: any = {
      event: 'ev_tarificacion',
      event_category: 'tarificacion',
      event_action: formName.layerName,
      event_label: 'gestion_de_polizas',
      categoria_seguro: 'jurídico',
      paso: 't3'
    };
    gtmService.pushTag(datalayerD);
  }

  /**
   * getGarantees
   * @param formDataValue formDataValue
   * @returns returns
   */
  getGarantees(formDataValue: any): ListaGarantiasInterface[] {
    const garantees: any = formDataValue.guaranteeSelectionList;
    const garanteesList: ListaGarantiasInterface[] = garantees.map((el: any) => {
      return {
        ...el,
        idProducto: formDataValue.guaranteeLimitOfMedicalExpenses.idProducto,
        idAmbito: + formDataValue.countryDestinyEnvironment
      };
    });
    return garanteesList;
  }

  /**
   * getFormData
   * @param formData formData
   * @returns returns
   */
  getFormData(formData: FormGroup): FormName {
    return formData.get('insureSelected').value;
  }
}
